import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useAppSelector } from '@/redux/Hook';
import { buildRouteRoleMap } from '@/utils/routeRoleMap';
import { menuItems } from '@/layouts/hydrogen/menu-items';
import { buildRouteChildMap, buildRouteModuleMap, canEmployeeOpen, parseEmployeeModules } from '@/utils/employeeModuleAccess';

export const useRouteGuard = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { user } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (!user) return;

    const routeMap = buildRouteRoleMap();
    const allowedRoles = routeMap[pathname];

    // 🚨 If route exists AND role not allowed
    if (allowedRoles && !allowedRoles.includes(user.role)) {
      if (user?.role === 'EMPLOYEE') {
        // Employees are not matched by role: they are limited by the modules their vendor granted.
        //@ts-expect-error modules is stored as a JSON string on the profile
        const modules = parseEmployeeModules(user?.modules);
        if (canEmployeeOpen(pathname, modules, buildRouteModuleMap(menuItems as any), buildRouteChildMap(menuItems as any))) return;
      }
      router.replace('/access-denied');
      return;
    }

    if (user?.role === 'EMPLOYEE') {
      //@ts-expect-error modules is stored as a JSON string on the profile
      const modules = parseEmployeeModules(user?.modules);
      if (!canEmployeeOpen(pathname, modules, buildRouteModuleMap(menuItems as any), buildRouteChildMap(menuItems as any))) {
        // POS-only staff land on the POS instead of an access-denied page when they open the dashboard.
        router.replace(pathname === '/' && modules.includes('POS') ? '/pos' : '/access-denied');
      }
    }
  }, [pathname, user]);
};